import React from 'react';
import { Modal } from '../../../../components/containers/Modal';
import classes from './DesignInCanvaModal.module.scss';
import { SocialNetworksEnum } from '../../../../constants/social-networks';
import classNames from 'classnames';
import { ReactComponent as Facebook } from './icons/facebook.svg';
import { ReactComponent as Pinterest } from './icons/pinterest.svg';
import { ReactComponent as Instagram } from './icons/instagram.svg';
import { ReactComponent as Twitter } from './icons/x.svg';
import { ReactComponent as Youtube } from './icons/youtube.svg';

type DesignInCanvaModalViewProps = {
  onCloseHandler: VoidFunction;
  openCanvaTemplate: (width: number, height: number) => void;
};

type TemplateCardProps = {
  title: string;
  socialMedia:
    | null
    | SocialNetworksEnum.twitter
    | SocialNetworksEnum.facebook
    | SocialNetworksEnum.instagram
    | SocialNetworksEnum.pinterest
    | 'youtube';
  aspectRatio: string;
  width: number;
  height: number;
  heightRatio: number;
  openCanvaTemplate: (width: number, height: number) => void;
};

const TemplateCard = ({
  title,
  socialMedia,
  aspectRatio,
  width,
  height,
  heightRatio,
  openCanvaTemplate
}: TemplateCardProps) => {
  const baseWidth = 167;
  const heightPixels = heightRatio * baseWidth;
  const icons = {
    [SocialNetworksEnum.twitter]: <Twitter />,
    [SocialNetworksEnum.facebook]: <Facebook />,
    [SocialNetworksEnum.instagram]: <Instagram />,
    [SocialNetworksEnum.pinterest]: <Pinterest />,
    youtube: <Youtube />
  };
  return (
    <div className={classes.AspectRatioContainer} onClick={() => openCanvaTemplate(width, height)}>
      <div
        className={classNames(classes.AspectRatioContent, classes[`Color${socialMedia ?? 'info'}`])}
        style={{ height: heightPixels }}>
        {socialMedia && (
          <div className={classNames(classes.IconContainer, socialMedia === 'youtube' && classes.YoutubeFill)}>
            {icons[socialMedia]}
          </div>
        )}

        <h2>{aspectRatio}</h2>
        <p>{`${width} x ${height}px`}</p>
      </div>
      <div>
        <p>{title}</p>
      </div>
    </div>
  );
};
export const DesignInCanvaModalView = ({ onCloseHandler, openCanvaTemplate }: DesignInCanvaModalViewProps) => {
  return (
    <Modal title={'Design in Canva'} onClose={onCloseHandler} showCloseIcon={true} size={'hugging'}>
      <div className={classNames('grid-x grid-padding-x', classes.Content)}>
        <div className={classNames('cell small-6 medium-3', classes.ContainerTest)}>
          <TemplateCard
            title={'Facebook Post'}
            heightRatio={1 / 1.2}
            aspectRatio={'1.2:1'}
            width={940}
            height={788}
            socialMedia={SocialNetworksEnum.facebook}
            openCanvaTemplate={openCanvaTemplate}
          />
          <TemplateCard
            title={'Instagram Post'}
            heightRatio={1}
            width={1080}
            height={1080}
            aspectRatio={'1:1'}
            socialMedia={SocialNetworksEnum.instagram}
            openCanvaTemplate={openCanvaTemplate}
          />
        </div>
        <div className={classNames('cell small-6 medium-3', classes.ContainerTest)}>
          <TemplateCard
            title={'Facebook Ads'}
            heightRatio={1 / 1.91}
            width={1200}
            height={628}
            aspectRatio={'1.91:1'}
            socialMedia={SocialNetworksEnum.facebook}
            openCanvaTemplate={openCanvaTemplate}
          />
          <TemplateCard
            heightRatio={16 / 9}
            title={'Instagram Story'}
            width={1080}
            height={1920}
            aspectRatio={'9:16'}
            socialMedia={SocialNetworksEnum.instagram}
            openCanvaTemplate={openCanvaTemplate}
          />
        </div>
        <div className={classNames('cell small-6 medium-3', classes.ContainerTest)}>
          <TemplateCard
            heightRatio={9 / 16}
            title={'X (Twitter) Post'}
            width={940}
            height={788}
            aspectRatio={'16:9'}
            socialMedia={SocialNetworksEnum.twitter}
            openCanvaTemplate={openCanvaTemplate}
          />
          <TemplateCard
            heightRatio={3 / 2}
            title={'Pinterest Graphic'}
            width={720}
            height={1080}
            aspectRatio={'2:3'}
            socialMedia={SocialNetworksEnum.pinterest}
            openCanvaTemplate={openCanvaTemplate}
          />
        </div>
        <div className={classNames('cell small-6 medium-3', classes.ContainerTest)}>
          <TemplateCard
            heightRatio={9 / 16}
            title={'YouTube Thumbnail'}
            width={1600}
            height={900}
            aspectRatio={'16:9'}
            socialMedia={'youtube'}
            openCanvaTemplate={openCanvaTemplate}
          />
          <TemplateCard
            heightRatio={5 / 2}
            title={'Infographics'}
            width={432}
            height={1080}
            aspectRatio={'2:5'}
            socialMedia={null}
            openCanvaTemplate={openCanvaTemplate}
          />
        </div>
      </div>
    </Modal>
  );
};
